import { useQueryContext } from '@sierralabs/query-ui';
/**
 * Returns a filtered array of Query objects based on the component tree. The
 * hook will crawl the component tree upwards to build a list of all referenced
 * queries.
 */
export function useGetQueriesForComponentTree(component) {
    const { queries } = useQueryContext();
    const getQueriesFromComponent = (component, results = []) => {
        if (component.queryIds) {
            results.push(...queries.filter(q => { var _a; return (_a = component.queryIds) === null || _a === void 0 ? void 0 : _a.includes(q.id); }));
        }
        if (component.parent) {
            getQueriesFromComponent(component.parent, results);
        }
        return results;
    };
    return component ? getQueriesFromComponent(component) : [];
}
//# sourceMappingURL=useGetQueriesForComponentTree.js.map